/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import React, { useState, useCallback, useEffect } from 'react';
import ReactModal from 'react-modal';
import { distributorService } from '../../../../service/distributor.service';
import AddASEModal from './AddASEModal';

export default function AddASE({
    OrderDetails, setOrderDetails, distributorDetails, handleAddASE,
}) {
    const [rolesParams, setrolesParams] = useState({
        type: 'ASE',
        search: '',
    });
    const [addPopup, setaddPopup] = useState(false);
    const [roles, setroles] = useState([]);
    const getRolesDetails = useCallback(
        async () => {
            const roleDetail = await distributorService.GetRoleDetails('area_sales_engineer', rolesParams.search);
            if (roleDetail.data?.success_status && roleDetail.data.data.Items.length > 0) {
                setroles(roleDetail.data.data.Items);
            } else {
                setroles([]);
            }
        },
        [rolesParams],
    );
    useEffect(() => {
        getRolesDetails();
    }, [getRolesDetails]);

    return (
        <div className="p-3 my-4 border-2 border-[#E29300] rounded-md bg-[#FFF5E2] assign ">
            <p className="font-semibold text-base text-[#090406]">Assigned ASE(s)</p>
            <button onClick={() => setaddPopup(true)} type="button" className="flex items-center mt-3.5" data-bs-toggle="modal" data-bs-target="#modalase">
                <img src="/images/addASE.svg" alt="icon" />
                <span className="text-sm font-semibold text-[#090406] pl-2.5">Add an ASE</span>
            </button>
            <ReactModal isOpen={addPopup}>
                <AddASEModal
                    OrderDetails={OrderDetails}
                    setOrderDetails={setOrderDetails}
                    getRolesDetails={getRolesDetails}
                    roles={roles}
                    distributorDetails={distributorDetails}
                    setrolesParams={setrolesParams}
                    setaddPopup={setaddPopup}
                    handleAddASE={handleAddASE}
                />
            </ReactModal>
        </div>
    );
}
